import React from 'react';
import { PoliciesModal, usePoliciesModal } from './PoliciesModal';
export function SalesFooter() {
  const policies = usePoliciesModal();
  return <>
      <footer className="bg-[#0A0A0A] py-12 px-4 border-t border-neutral-900 text-center" data-id="element-123">
        <div className="max-w-4xl mx-auto" data-id="element-124">
          <h3 className="text-xl font-black text-white uppercase tracking-wider mb-4 opacity-50" data-id="element-125">
            Tu Primer Sueldo en Dólares
          </h3>
          <p className="text-neutral-600 text-sm mb-4" data-id="element-126">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>

          <button onClick={policies.open} className="text-[#C9A84C] hover:text-[#C9A84C]/80 text-sm underline underline-offset-2 transition-colors mb-6 inline-block" data-id="element-127">
            Políticas y Condiciones
          </button>

          <p className="text-neutral-700 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-128">
            Descargo de responsabilidad: Los resultados mencionados en esta
            página no son típicos y dependen del esfuerzo individual, la
            dedicación y la implementación de las estrategias descritas en el
            manual. Esta página no está afiliada ni respaldada por Facebook,
            Google, Airtm o Wise.
          </p>
        </div>
      </footer>

      <PoliciesModal isOpen={policies.isOpen} onClose={policies.close} data-id="element-129" />
    </>;
}